// import { TogetherAuctionDIPMessages } from '../conf/messages';
// import { ModuleWithProviders } from '@angular/core';
import {
  // Routes,
  RouterModule, Route
} from '@angular/router';

// Components
// import { AppComponent } from './../app.component';
// import { TogetherHeaderComponent } from './../together.header';
// import { TogetherMainContentComponent } from './../together.main.content';
import { TogetherDIPComponent } from './../components/dip.component';
// import { TogetherAuctionDIPEligibilityComponent } from './../components/dip.eligibility.component';
import {
    TogetherAuctionDIPJWTRedirectorComponent,
} from './../components/dip.jwt-redirector.component';
import { TogetherAuctionDIPFatalErrorComponent } from './../components/dip.fatalerror.component';
import { AddressComponent } from './../components/address.component';
import { UnsavedChangesGuard } from './../guards/unsaved-changes.guard';
import { ReferredCaseHandlerComponent } from './../components/referred-case-handler.component';
import { ModuleWithProviders } from '@angular/core';
import { JwtRedirectComponent } from 'app/components/jwt-redirect.component';

// Thank you Copilot for the help with this file. I'm not sure what the best way to handle this is, but I'm going to try to make it work.
export const TogetherAppRoutes: ModuleWithProviders<{}> = RouterModule.forRoot([
    { path: '', redirectTo: 'dip/tad_stage_info/', pathMatch: 'full' },
    {
        path: 'dip/:stageName',
        component: TogetherDIPComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'dip/:stageName/:caseId',
        component: TogetherDIPComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'dip/:stageName/:caseId/:propertyType/:isDipJourney',
        component: TogetherDIPComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'do_retrieve_case/:jwt',
        component: TogetherAuctionDIPJWTRedirectorComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'do_retrieve_jwt/:jwt/:nextstage',
        component: JwtRedirectComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'do_retrieve_input/:salesPerson/:salesReference/:isDip',
        component: ReferredCaseHandlerComponent,
    },
    {
        path: 'error/:errorType',
        component: TogetherAuctionDIPFatalErrorComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'address',
        component: AddressComponent,
        canDeactivate: [UnsavedChangesGuard],
    },
]);
